import { HttpResult } from 'widgets-for-react'
import { getDrupalLanguage } from '../../../drupal/types_and_parser/extra_types.mod'
import { getLangFromUrl } from '../../utils/history.mod'
import { Vacancy } from './state'

export const getVacancy = (vacancyId: string): Promise<HttpResult<Vacancy>> =>
  fetch(`/api/v1/CustomFormLogic/GetVacancy/${getDrupalLanguage(getLangFromUrl())}/${vacancyId}`)
    .then((res) => res.json())
    .then((json) => json as { vacancy: Vacancy; job_posting_data: string })
    .then((value) => {
      var job_posting_script = document.createElement('div')
      job_posting_script.innerHTML = value.job_posting_data
      job_posting_script.id = 'job_posting'
      let job_posting_data = document.getElementById('job_posting')
      if (job_posting_data) job_posting_data.replaceWith(job_posting_script)

      return { kind: 'result', status: 200, value: value.vacancy }
    })
